import { TransfersDeletedComponent } from './transfers-deleted.component';
import { Routes } from '@angular/router';

export const TRANSFERS_DELETED_ROUTES: Routes = [
    {
        path: '',
        component: TransfersDeletedComponent,
        data: { section: "TEAM_TRANSFERS_DELETED", backEnabled: true }
    },
    {
        path: ':transferId/details',
        pathMatch: 'prefix',
        loadChildren: () => import('@app/client/account/team/transfers/transfer-details/transfer-details.module').then(m => m.TransferDetailsModule),
        data: { section: "TEAM_TRANSFERS_DETAILS", backEnabled: true }
    },
    // {
    //     path: ':transferId/activity',
    //     pathMatch: 'full',
    //     loadChildren: () => import('@app/client/account/team/transfers/transfer-activity/transfer-activity.module').then(m => m.TransferActivityModule),
    //     data: { section: "TEAM_TRANSFERS_ACTIVITY", backEnabled: true }
    // }
];
